module.exports = DllOfD3;